// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"3c48899bc6d01bb5","6831":"aaa2841051ad14aa","8503":"e4909c4f8649de1e","9683":"354f5c8200bc6c70"}[chunkId] + ".js";
};